import { DownloadOutlined, FilePdfOutlined } from '@ant-design/icons';
import {
  BackBar,
  DOCUMENT_TYPE_LABELS,
  downloadUrl,
  fullDate,
  present,
} from '@horof/shared';
import { Alert, Button, Image, Skeleton, Tag } from 'antd';
import { Link, useParams } from 'react-router';
import { useQuery } from 'urql';
import { documentsContext, PhoneDocumentDocument } from './documents-data';

/** One document: its details, its pages one under the other, its replies. */
export function DocumentPage() {
  const { documentId = '' } = useParams();
  const [{ data, error }] = useQuery({
    query: PhoneDocumentDocument,
    variables: { id: documentId },
    context: documentsContext,
  });
  const d = data?.associationDocument;
  const files = present(d?.files.nodes).flatMap((f) =>
    f.photo ? [f.photo] : [],
  );
  const original = d?.replyTo.nodes[0];

  return (
    <div className="page">
      <BackBar to="back" label="الوثائق" />
      {error && <Alert type="error" showIcon message="تعذّر تحميل الوثيقة" />}
      {!data && !error && <Skeleton active paragraph={{ rows: 8 }} />}
      {data && !d && (
        <Alert type="warning" showIcon message="الوثيقة غير موجودة" />
      )}
      {d && (
        <>
          <h1 className="member-title">{d.title}</h1>
          <div className="card doc-facts">
            <div>
              <Tag>{DOCUMENT_TYPE_LABELS[d.type]}</Tag>
              {d.reference && <Tag className="ltr-num">{d.reference}</Tag>}
              {d.isCurrent && <Tag color="green">النسخة المعتمدة</Tag>}
            </div>
            <div>التاريخ: {fullDate(d.documentDate)}</div>
            {d.counterparty && <div>الجهة: {d.counterparty.name}</div>}
            {d.project && <div>المشروع: {d.project.name}</div>}
            {d.replyDueOn && !d.repliedById && (
              <div>ننتظر الرد قبل: {fullDate(d.replyDueOn)}</div>
            )}
            {original && (
              <div>
                ردّ على:{' '}
                <Link to={`/documents/${original.id}`}>
                  {original.reference} {original.title}
                </Link>
              </div>
            )}
            {d.repliedBy && (
              <div>
                الرد:{' '}
                <Link to={`/documents/${d.repliedBy.id}`}>
                  {d.repliedBy.reference} {d.repliedBy.title}
                </Link>
              </div>
            )}
            {d.notes && <div className="field-hint">{d.notes}</div>}
          </div>

          {files.length === 0 && (
            <div className="field-hint">لا ملفات لهذه الوثيقة.</div>
          )}
          <Image.PreviewGroup>
            <div className="doc-pages">
              {files.map((f, i) =>
                f.contentType === 'application/pdf' ? (
                  <Button
                    key={f.id}
                    size="large"
                    block
                    icon={<FilePdfOutlined />}
                    href={f.url}
                    target="_blank"
                  >
                    فتح الملف (PDF)
                  </Button>
                ) : (
                  <figure key={f.id} className="doc-page">
                    <Image src={f.url} alt={`الصفحة ${i + 1}`} />
                    <figcaption>
                      الصفحة <span className="ltr-num">{i + 1}</span>
                      <a href={downloadUrl(f.url)}>
                        <DownloadOutlined /> تنزيل
                      </a>
                    </figcaption>
                  </figure>
                ),
              )}
            </div>
          </Image.PreviewGroup>
          <div className="field-hint">
            التعديل وترتيب الصفحات من الحاسوب («مكتب الجمعية»).
          </div>
        </>
      )}
    </div>
  );
}
